// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-pwd-container {
  height: 100vh;
  justify-content: center;
}
.reset-pwd-container .reset-container {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 11.97%, rgba(255, 255, 255, 0) 77.22%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  border-radius: 83px;
  margin-top: 15px;
  text-align: center;
}
.reset-pwd-container .email-wrapper {
  justify-content: center;
  padding: 10px;
}
.reset-pwd-container .continue-button {
  font-size: 12px;
  background: radial-gradient(58.52% 47.51% at 56.65% 47.58%, #059baf 0%, #007080 100%);
  border: 2px solid #ffffff;
  border-radius: 9px;
  padding: 2px;
  margin: 10px;
}
.reset-pwd-container .continue-button .MuiButton-root {
  padding: 0px;
  color: #ffffff;
}
.reset-pwd-container .continue-button .MuiButton-contained {
  box-shadow: none !important;
}
.reset-pwd-container .continue-button .MuiButton-containedPrimary,
.reset-pwd-container .continue-button .MuiButton-containedPrimary:hover {
  background: radial-gradient(58.52% 47.51% at 56.65% 47.58%, #059baf 0%, #007080 100%);
}
.reset-pwd-container .cancel-button {
  background: gray;
}
.reset-pwd-container .logo-title-wrapper {
  padding: 30px;
}
.reset-pwd-container .logo-title-wrapper .lcontainer {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: 50px;
}
.reset-pwd-container .logo-title-wrapper .lcontainer .logo > img {
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.reset-pwd-container .logo-title-wrapper .logo-class {
  font-style: normal;
  font-weight: bold;
  font-family: "Noto Sans", Arial, sans-serif;
  font-size: 30px;
  letter-spacing: -0.08em;
  color: #059baf;
  padding: 15px 0px 0px 0px;
}
.reset-pwd-container .logo-title-wrapper .logo-tagline-class {
  font-size: 10px;
  color: #009fe3;
  font-weight: 700;
  padding: 35px 0px 0px 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/resetPassword.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;AACF;AACE;EACE,mGAAA;EAGA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAIE;EACE,uBAAA;EACA,aAAA;AAFJ;AAKE;EACE,eAAA;EACA,qFAAA;EAGA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AALJ;AAOI;EACE,YAAA;EACA,cAAA;AALN;AAQI;EACE,2BAAA;AANN;AASI;;EAEE,qFAAA;AAPN;AAaE;EACE,gBAAA;AAXJ;AAcE;EAaE,aAAA;AAxBJ;AAYI;EAOE,aAAA;EACA,kCAAA;EACA,wBAAA;AAhBN;AAQM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AANR;AAgBI;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AAdN;AAiBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AAfN","sourcesContent":[".reset-pwd-container {\r\n  height: 100vh;\r\n  justify-content: center;\r\n\r\n  .reset-container {\r\n    background: linear-gradient(180deg,\r\n        rgba(255, 255, 255, 0.6) 11.97%,\r\n        rgba(255, 255, 255, 0) 77.22%);\r\n    border: 2px solid #ffffff;\r\n    box-sizing: border-box;\r\n    border-radius: 83px;\r\n    margin-top: 15px;\r\n    text-align: center;\r\n  }\r\n\r\n  .email-wrapper {\r\n    justify-content: center;\r\n    padding: 10px;\r\n  }\r\n\r\n  .continue-button {\r\n    font-size: 12px;\r\n    background: radial-gradient(58.52% 47.51% at 56.65% 47.58%,\r\n        #059baf 0%,\r\n        #007080 100%);\r\n    border: 2px solid #ffffff;\r\n    border-radius: 9px;\r\n    padding: 2px;\r\n    margin: 10px;\r\n\r\n    .MuiButton-root {\r\n      padding: 0px;\r\n      color: #ffffff;\r\n    }\r\n\r\n    .MuiButton-contained {\r\n      box-shadow: none !important;\r\n    }\r\n\r\n    .MuiButton-containedPrimary,\r\n    .MuiButton-containedPrimary:hover {\r\n      background: radial-gradient(58.52% 47.51% at 56.65% 47.58%,\r\n          #059baf 0%,\r\n          #007080 100%);\r\n    }\r\n  }\r\n\r\n  .cancel-button {\r\n    background: gray;\r\n  }\r\n\r\n  .logo-title-wrapper {\r\n    .lcontainer {\r\n      .logo>img {\r\n        width: 70px;\r\n        height: 70px;\r\n        object-fit: cover;\r\n      }\r\n\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr 2fr;\r\n      grid-template-rows: 50px;\r\n    }\r\n\r\n    padding: 30px;\r\n\r\n    .logo-class {\r\n      font-style: normal;\r\n      font-weight: bold;\r\n      font-family: 'Noto Sans', Arial, sans-serif;\r\n      font-size: 30px;\r\n      letter-spacing: -0.08em;\r\n      color: #059baf;\r\n      padding: 15px 0px 0px 0px;\r\n    }\r\n\r\n    .logo-tagline-class {\r\n      font-size: 10px;\r\n      color: #009fe3;\r\n      font-weight: 700;\r\n      padding: 35px 0px 0px 5px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
